export enum AvatarKind {
  VOICE_ONLY = 'voice_only',
  LIBRARY = 'library',
  CUSTOM = 'custom',
}

export enum ConfigMode {
  LIBRARY = 'library',
  CUSTOM = 'custom',
}
